import { NavDirections } from '@eventbrite/collection-carousel';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { Link } from 'react-router-dom';

import {
    useIsInViewPort,
    useSetDisabledNav,
} from '@eventbrite/collection-carousel';
import { OrganicEventSearchFiltersApiPayload } from '../../../../../api/searchOrganicEvents';
import { CarouselCard } from '../../../../../components/Carousel';
import { TrackingContext } from '../../../../../trackingContext';
import { isLanguageSubfolderUsedForLocale } from '../../../../../utils/location';
import { FormattedLocationResponse } from '../../../api';
import { CategoryContent, CATEGORY_CONTENT_MAP } from '../../../constants';
import { generateBrowseUrl } from '../../../utils';

interface SingleSubCategoryProps {
    subCategory: { key: string };
    totalLength: number;
    setDisabledNav: React.Dispatch<
        React.SetStateAction<NavDirections | undefined>
    >;
    query: OrganicEventSearchFiltersApiPayload;
    location: FormattedLocationResponse;
    activeTag: CategoryContent;
    index: number;
}

export const SingleSubCategory = ({
    subCategory,
    totalLength,
    setDisabledNav,
    query,
    location,
    activeTag,
    index,
}: SingleSubCategoryProps) => {
    const slideRef = React.useRef<HTMLLIElement>(null);
    const isLastSlide = index === totalLength - 1;
    const isFirstSlide = index === 0;
    const { isVisible } = useIsInViewPort({
        ref: slideRef,
        trackVisibility: isLastSlide || isFirstSlide,
    });

    const localeContext = React.useContext(TrackingContext);
    const locale = isLanguageSubfolderUsedForLocale(localeContext.locale)
        ? '/' + localeContext.locale
        : '';

    useSetDisabledNav({
        isLastSlide,
        isFirstSlide,
        isVisible,
        setDisabledNav,
    });

    return (
        <li ref={slideRef} key={index}>
            <Link
                key={index}
                to={generateBrowseUrl(
                    { ...query, tags: [subCategory?.key ?? ''] },
                    location,
                    locale,
                )}
                onClick={() => {
                    typeof window !== 'undefined'
                        ? window.scrollTo(0, 0)
                        : null;
                    trackAnalyticsEvent({
                        category: 'category-page',
                        action: 'SubcategoryClicked',
                        label: CATEGORY_CONTENT_MAP[subCategory?.key || '']
                            .title,
                    });
                }}
            >
                <CarouselCard
                    title={CATEGORY_CONTENT_MAP[subCategory?.key || ''].title}
                    imageUrl={
                        CATEGORY_CONTENT_MAP[subCategory?.key || '']
                            .imageUrlSmall ||
                        CATEGORY_CONTENT_MAP[activeTag?.key || ''].imageUrlSmall
                    }
                    imageLoading={'lazy'}
                />
            </Link>
        </li>
    );
};
